import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="w-full bg-background-50">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 md:py-20 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-node-tree" />
            事件脉络 · 一次讲清
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 text-balance md:text-5xl">
            海角黑料事件始末时间线梳理
          </h1>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            起因、经过、后续，一次讲清。
            <span className="mt-2 block text-foreground-500">
              按时间线梳理海角黑料事件全貌，从起因到经过再到后续进展。想快速看懂海角黑料始末、掌握事件关键节点，这里给你清晰完整的事件脉络。
            </span>
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#timeline"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-play-list-2-line" />
              查看完整时间线
            </a>
            <a
              href="#cause"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
            >
              <i className="ri-question-line" />
              先看事件起因
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-x-6 gap-y-4 border-t border-background-200 pt-6 sm:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <dt className="text-xs text-foreground-500">{stat.label}</dt>
                <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">
                  {stat.value}
                  <span className="ml-0.5 text-sm font-medium text-foreground-500">
                    {stat.unit}
                  </span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <div className="relative h-[340px] w-full overflow-hidden rounded-lg border border-background-200 sm:h-[420px] lg:h-[500px]">
            <img
              src="https://readdy.ai/api/search-image?query=moody%20editorial%20photograph%20of%20abstract%20flowing%20ink%20and%20layered%20paper%20textures%20on%20a%20cream%20desk%2C%20folded%20newspaper%20silhouettes%2C%20dramatic%20warm%20light%2C%20warm%20cream%20and%20deep%20vermilion%20palette%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20subtle%20film%20grain%2C%20no%20people%2C%20cinematic%20and%20atmospheric%2C%20high%20detail&width=900&height=1100&seq=hej-hero-01&orientation=portrait"
              alt="海角黑料事件始末时间线主题图"
              title="海角黑料事件始末时间线"
              className="h-full w-full object-top"
            />
            <div className="absolute inset-x-4 bottom-4 rounded-lg border border-background-200 bg-background-50/95 p-4 backdrop-blur">
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 text-xs text-foreground-600">
                  <i className="ri-map-pin-time-line text-primary-500" />
                  当前阅读位置
                </div>
                <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-800">
                  更新至 09-04
                </span>
              </div>
              <p className="mt-2 text-sm font-medium text-foreground-900">
                从 05-02 的起因线索，到 09-04 的最新后续
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}